import { Modal, Button } from "react-bootstrap";
import PhoneInputWithNumpad from "./PhoneInputWithNumpad";
import useFlow from "../hooks/useFlow";

export default function PurchaseErrorNoAuthModal({
  show,
  handleClose = () => {},
  handlerYes = () => {},
  phone,
  setPhone,
  loading,
}) {
  const { locationPreferences } = useFlow();
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Oops, sorry about that</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          Give us your phone number and the support will help you complete your
          transaction!
        </div>
        <PhoneInputWithNumpad
          value={phone}
          onChange={setPhone}
          placeholder="(512) 555-0123"
          disabled={loading}
          showNumpad={locationPreferences?.showPhoneNumpad}
          numpadInline
        />
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button
          variant="btn btn-outline-primary"
          data-testid="purchase-error-cancel-btn"
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button variant="primary" data-testid="purchase-error-submit-btn" onClick={handlerYes} disabled={loading}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
